import DownloadIcon from '@atlaskit/icon/core/download';
import * as React from 'react';

export function SvgDownload() {
  return <DownloadIcon label="" testId="ads-refreshed-icon" />;
}
